import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Alert,
  Box,
  Chip,
  Paper,
  CircularProgress,
  Grid,
  Icon
} from '@mui/material';
import { useApiCall } from '../utils/hooks';
import { pdfApi } from '../utils/api';

function PDFStatus() {
  const [result, setResult] = useState(null);
  const [productName, setProductName] = useState('');
  const { loading, execute } = useApiCall();

  const handleCheckStatus = async () => {
    try {
      const data = await execute(() => pdfApi.getStatus({ product: productName }));
      
      setResult({
        success: true,
        status: 'Success',
        data: data
      });
    } catch (error) {
      setResult({
        error: error.message,
        success: false
      });
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
            PDF Status Service
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Check the processing status and availability of PDFs for a specific product.
          </Typography>
        </CardContent>
      </Card>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            API Documentation
          </Typography>
          <Box sx={{ mb: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Chip label="GET" color="success" size="small" sx={{ mr: 1 }} />
            <Typography component="span" sx={{ fontFamily: 'monospace' }}>
              /api/pdf-status?product=productName
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" paragraph>
            Returns the status of PDFs for a given product name.
          </Typography>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            Status Checker
          </Typography>
          
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Product Name"
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
                placeholder="Enter product name to check PDF status"
              />
            </Grid>
            
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={handleCheckStatus}
                disabled={loading || !productName.trim()}
                startIcon={loading ? <CircularProgress size={20} /> : <Icon>info</Icon>}
              >
                {loading ? 'Checking...' : 'Check Status'}
              </Button>
            </Grid>
          </Grid>

          {result && (
            <Box sx={{ mt: 3 }}>
              {result.error ? (
                <Alert severity="error">
                  Error: {result.error}
                </Alert>
              ) : (
                <>
                  <Typography variant="body2" gutterBottom>
                    Status: <Chip 
                      label={result.status} 
                      color={result.success ? 'success' : 'error'} 
                      size="small" 
                    />
                  </Typography>
                  <Paper sx={{ p: 2, bgcolor: 'grey.50', mt: 1 }}>
                    <pre style={{ 
                      margin: 0, 
                      fontFamily: 'monospace', 
                      fontSize: '0.875rem',
                      whiteSpace: 'pre-wrap'
                    }}>
                      {JSON.stringify(result.data, null, 2)}
                    </pre>
                  </Paper>
                </>
              )}
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}

export default PDFStatus;
